/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MdmPolicyRematchJobRequest
 */
export interface MdmPolicyRematchJobRequest {
    /**
     * 
     * @type {string}
     * @memberof MdmPolicyRematchJobRequest
     */
    assetClass?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmPolicyRematchJobRequest
     */
    policyConfigurationId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MdmPolicyRematchJobRequest
     */
    acknowledgedRematch?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MdmPolicyRematchJobRequest
     */
    dryRun?: boolean;
}

/**
 * Check if a given object implements the MdmPolicyRematchJobRequest interface.
 */
export function instanceOfMdmPolicyRematchJobRequest(value: object): value is MdmPolicyRematchJobRequest {
    return true;
}

export function MdmPolicyRematchJobRequestFromJSON(json: any): MdmPolicyRematchJobRequest {
    return MdmPolicyRematchJobRequestFromJSONTyped(json, false);
}

export function MdmPolicyRematchJobRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MdmPolicyRematchJobRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'assetClass': json['assetClass'] == null ? undefined : json['assetClass'],
        'policyConfigurationId': json['policyConfigurationId'] == null ? undefined : json['policyConfigurationId'],
        'acknowledgedRematch': json['acknowledgedRematch'] == null ? undefined : json['acknowledgedRematch'],
        'dryRun': json['dryRun'] == null ? undefined : json['dryRun'],
    };
}

export function MdmPolicyRematchJobRequestToJSON(json: any): MdmPolicyRematchJobRequest {
    return MdmPolicyRematchJobRequestToJSONTyped(json, false);
}

export function MdmPolicyRematchJobRequestToJSONTyped(value?: MdmPolicyRematchJobRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assetClass': value['assetClass'],
        'policyConfigurationId': value['policyConfigurationId'],
        'acknowledgedRematch': value['acknowledgedRematch'],
        'dryRun': value['dryRun'],
    };
}

